
(function() {
  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // === CARROUSEL HERO DYNAMIQUE (auto-play + flèches + dots + swipe) ===
  function initHeroCarousel() {
    const carousel = document.querySelector('.hero-carousel');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.hero-carousel-slide');
    const dots   = carousel.querySelectorAll('.hero-carousel-dot');
    const prevBtn = carousel.querySelector('.hero-carousel-arrow.prev');
    const nextBtn = carousel.querySelector('.hero-carousel-arrow.next');
    const total = slides.length;
    if (total <= 1) return;

    let current = 0;
    let autoplay = null;
    const DELAY = 5000;

    function show(index) {
      current = (index + total) % total;
      slides.forEach((s, i) => s.classList.toggle('active', i === current));
      dots.forEach((d, i) => d.classList.toggle('active', i === current));
    }
    function next() { show(current + 1); }
    function prev() { show(current - 1); }
    function startAutoplay() {
      stopAutoplay();
      autoplay = setInterval(next, DELAY);
    }
    function stopAutoplay() {
      if (autoplay) { clearInterval(autoplay); autoplay = null; }
    }
    function userAction(fn) {
      return function(e) {
        if (e) e.stopPropagation();
        fn();
        startAutoplay();
      };
    }

    if (prevBtn) prevBtn.addEventListener('click', userAction(prev));
    if (nextBtn) nextBtn.addEventListener('click', userAction(next));
    dots.forEach((dot, i) => dot.addEventListener('click', userAction(() => show(i))));

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    let touchStartX = 0;
    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });
    carousel.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next(); else prev();
      }
      startAutoplay();
    }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });

    startAutoplay();
  }

  // Lancer dès que le DOM est prêt (le script est en bas du body donc DOM déjà parsé)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroCarousel);
  } else {
    initHeroCarousel();
  }

  // === CART DRAWER ===
  const cartTrigger  = document.getElementById('cart-trigger');
  const cartDrawer   = document.getElementById('cart-drawer');
  const cartOverlay  = document.getElementById('cart-overlay');
  const cartClose    = document.getElementById('cart-drawer-close');
  const cartBody     = document.getElementById('cart-drawer-body');
  const cartFooter   = document.getElementById('cart-drawer-footer');
  const cartCountEl  = document.getElementById('cart-count');

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function giftLine(emoji, title, sub) {
    return '<div class="cart-gift-item">' +
             '<div class="cart-gift-icon">' + emoji + '</div>' +
             '<div class="cart-gift-info">' +
               '<div class="cart-gift-title">' + escapeHtml(title) + '</div>' +
               '<div class="cart-gift-sub">' + escapeHtml(sub) + '</div>' +
             '</div>' +
             '<div class="cart-gift-price">Offert</div>' +
           '</div>';
  }

  function updateCartCount(count) {
    if (!cartCountEl) return;
    cartCountEl.textContent = count;
    cartCountEl.style.display = count > 0 ? 'flex' : 'none';
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<div class="cart-empty"><p>🌿</p><p>Votre panier est vide.</p><a href="/collections/all">Voir les créations</a></div>';
      cartFooter.innerHTML = '';
      return;
    }

    // --- Compteurs simples par type de produit ---
    // Règle : 2 tableaux ou + = pack (remise + cadeaux), 1 = solo. Idem boîtes.
    // On ne dépend plus de _pack_id / _pack_size (source des bugs "pack incomplet").
    function isGravItem(it) {
      return (it.handle === 'gravure-du-prenom') || /^gravure du pr/i.test(it.product_title || '');
    }
    function isPackItem(it) {
      // Pack Aventure : 1 tableau + 1 boîte dans un seul produit (handle "pack-aventure")
      return (it.handle === 'pack-aventure') || /pack aventure/i.test(it.product_title || '');
    }
    function isBoxItem(it) {
      if (isGravItem(it) || isPackItem(it)) return false;
      return (it.handle === 'les-tresors') || /bo[iî]te|tr[ée]sor/i.test(it.product_title || '');
    }
    function isTableauItem(it) {
      if (isGravItem(it) || isPackItem(it)) return false;
      return (it.handle === 'tableau-floral') || (it.handle === 'petale-bois') || /tableau|p[ée]tale/i.test(it.product_title || '');
    }

    // Nettoyage : une ligne "Gravure du prénom" (2 €) doit toujours être liée à son tableau via _gravure_id.
    // Si le tableau a été retiré, on retire la gravure automatiquement.
    if (!renderCart._cleaning) {
      var gravIds = {};
      cart.items.forEach(function(it) {
        if (!isGravItem(it) && it.properties && it.properties['_gravure_id']) gravIds[it.properties['_gravure_id']] = true;
      });
      var orphans = cart.items.filter(function(it) {
        return isGravItem(it) && !(it.properties && it.properties['_gravure_id'] && gravIds[it.properties['_gravure_id']]);
      });
      if (orphans.length) {
        renderCart._cleaning = true;
        var chain = Promise.resolve();
        orphans.forEach(function(o) {
          chain = chain.then(function() {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: 'id=' + encodeURIComponent(o.key) + '&quantity=0'
            });
          });
        });
        chain
          .then(function() { return fetch('/cart.js'); })
          .then(function(r) { return r.json(); })
          .then(function(c) { renderCart._cleaning = false; renderCart(c); })
          .catch(function() { renderCart._cleaning = false; });
        return;
      }
    }

    var tableauCount = cart.items.reduce(function(n, it) { return n + (isTableauItem(it) ? it.quantity : 0); }, 0);
    var boxCount = cart.items.reduce(function(n, it) { return n + (isBoxItem(it) ? it.quantity : 0); }, 0);
    var packCount = cart.items.reduce(function(n, it) { return n + (isPackItem(it) ? it.quantity : 0); }, 0);

    cartBody.innerHTML = cart.items.map(function(item, idx) {
      // Prix unitaire réel (plein tarif). La remise est gérée par Shopify et récapitulée en bas.
      var unitPrice = item.original_price != null ? item.original_price : item.price;
      var lineFull = unitPrice * item.quantity;
      var isGrav = isGravItem(item);

      // Propriétés visibles (on masque les techniques _pack_id / _pack_size / Formule)
      var propsHtml = Object.entries(item.properties || {})
        .filter(function(e) {
          var k = e[0], v = e[1];
          if (!v || String(v).trim() === '') return false;
          if (k.charAt(0) === '_') return false;
          if (k === 'Formule') return false;
          return true;
        })
        .map(function(e) {
          if (e[0] === 'Prénom à graver') {
            return '<div class="cart-item-property" style="color:var(--green-deep,#3E5622);font-weight:800;font-size:0.95rem;">✏️ Prénom gravé : <strong>« ' + escapeHtml(String(e[1])) + ' »</strong></div>' +
                   (isGrav ? '' : '<div class="cart-item-property" style="font-size:0.75rem;color:#7a6f57;">Gravé exactement comme écrit ci-dessus</div>');
          }
          if (e[0].indexOf('Prénom à graver') === 0) {
            // Pack Aventure : "Prénom à graver (tableau)" / "Prénom à graver (boîte)"
            var where = e[0].replace('Prénom à graver', '').replace(/[()]/g, '').trim();
            return '<div class="cart-item-property" style="color:var(--green-deep,#3E5622);font-weight:800;font-size:0.95rem;">✏️ Prénom gravé' + (where ? ' (' + escapeHtml(where) + ')' : '') + ' : <strong>« ' + escapeHtml(String(e[1])) + ' »</strong></div>';
          }
          return '<div class="cart-item-property">' + escapeHtml(e[0]) + ' : <strong>' + escapeHtml(String(e[1])) + '</strong></div>';
        }).join('');

      var qtyHtml = isGrav
        ? '<div class="cart-item-qty" style="border:none;background:transparent;font-size:0.78rem;color:#7a6f57;padding:0;">Gravée dans notre atelier</div>'
        : '<div class="cart-item-qty">' +
            '<button type="button" class="qty-minus" data-index="' + idx + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" class="qty-plus" data-index="' + idx + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div>';

      return '<div class="cart-item' + (isGrav ? ' cart-item--grav' : '') + '">' +
        (item.image
          ? '<img class="cart-item-img" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">'
          : '<div class="cart-item-img-placeholder">' + (isGrav ? '✏️' : '🎁') + '</div>') +
        '<div class="cart-item-info">' +
          '<div class="cart-item-title">' + escapeHtml(item.product_title) + '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="cart-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
          propsHtml +
          '<div class="cart-item-bottom">' +
            qtyHtml +
            '<div class="cart-item-price">' + formatMoney(lineFull) + '</div>' +
          '</div>' +
          '<button type="button" class="cart-item-remove" data-index="' + idx + '">Supprimer</button>' +
        '</div>' +
      '</div>';
    }).join('');

    // --- Cadeaux & avantages (basés sur les compteurs simples) ---
    var hasTableau = tableauCount >= 1 || packCount >= 1;   // le pack contient 1 tableau
    var hasBox = boxCount >= 1 || packCount >= 1;           // et 1 boîte
    var hasTableauPack = tableauCount >= 2;   // 2 tableaux ou + = remise pack
    var hasBoxDuo = boxCount >= 2;            // 2 boîtes ou + = avantages

    // Livraison offerte dès 30€ d'achat OU pour les packs Duo OU pour un Pack Aventure
    var fullTotal = cart.items.reduce(function(sum, it) {
      var u = it.original_price != null ? it.original_price : it.price;
      return sum + u * it.quantity;
    }, 0);

    var freeShip = (fullTotal >= 3000) || hasTableauPack || hasBoxDuo || packCount >= 1;
    var ebook = hasTableau || hasBox;

    var gifts = '';

    // Gravure des prénoms offerte : boîtes (toujours), tableaux en pack (2 ou +),
    // et Pack Aventure (tableau + boîte, jusqu'à 2 prénoms par pack)
    var freeGravCount = 0;
    cart.items.forEach(function(it) {
      if (isPackItem(it) && it.properties) {
        if (it.properties['Prénom à graver (tableau)']) freeGravCount += it.quantity;
        if (it.properties['Prénom à graver (boîte)']) freeGravCount += it.quantity;
        return;
      }
      if (it.properties && it.properties['Prénom à graver']) {
        if (isBoxItem(it)) freeGravCount += it.quantity;
        else if (isTableauItem(it) && tableauCount >= 2) freeGravCount += it.quantity;
      }
    });
    if (freeGravCount > 0) {
      var gravVal = (freeGravCount * 2).toFixed(2).replace('.', ',') + ' €';
      gifts += giftLine('✏️',
        freeGravCount > 1 ? 'Gravure des prénoms offerte' : 'Gravure du prénom offerte',
        freeGravCount > 1 ? freeGravCount + ' prénoms gravés · valeur ' + gravVal : 'Valeur 2,00 €, gravée dans notre atelier');
    }

    // Porte-clé : OFFERT DANS TOUS LES CAS
    gifts += giftLine('🔑', 'Porte-clé en bois Kidiz\'plorer', 'Gravé dans notre atelier');
    if (ebook) {
      gifts += giftLine('📖', 'E-book offert', 'Idées de balades & activités nature');
    }
    if (freeShip) {
      gifts += giftLine('🚚', 'Livraison offerte', 'Ajoutée à votre commande');
    }
    if (gifts) {
      cartBody.insertAdjacentHTML('beforeend',
        '<div class="cart-gifts"><div class="cart-gifts-label">🎁 Vos cadeaux offerts</div>' + gifts + '</div>');
    }

    // --- Footer : total + remise réelle + note livraison ---
    var saved = (cart.original_total_price || cart.total_price) - cart.total_price;
    var remaining = 3000 - fullTotal;
    cartFooter.innerHTML =
      (saved > 0 ? '<div class="cart-saving">🎉 Réduction pack : −' + formatMoney(saved) + '</div>' : '') +
      '<div class="cart-total">' +
        '<span>Total</span>' +
        '<span class="cart-total-price">' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<a href="/checkout" class="cart-checkout-btn">Passer la commande</a>' +
      (freeShip
        ? '<p class="cart-shipping-note">🚚 Livraison offerte débloquée !</p>'
        : '<p class="cart-shipping-note">🚚 Plus que ' + formatMoney(remaining) + ' pour la livraison offerte</p>');

    var snapItems = cart.items.slice();
    cartBody.querySelectorAll('.qty-minus, .qty-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(snapItems, parseInt(this.dataset.index), Math.max(0, parseInt(this.dataset.qty)));
      });
    });
    cartBody.querySelectorAll('.cart-item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(snapItems, parseInt(this.dataset.index), 0);
      });
    });
  }

  function updateCartItem(items, idx, qty) {
    var targetItem = items[idx];
    var body = 'id=' + encodeURIComponent(targetItem.key) + '&quantity=' + qty;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body
    })
    .then(function() {
      return fetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(renderCart);
  }

  function openDrawer() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      renderCart(cart);
      cartDrawer.classList.add('active');
      cartOverlay.classList.add('active');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeDrawer() {
    cartDrawer.classList.remove('active');
    cartOverlay.classList.remove('active');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.openCartDrawer = openDrawer;

  if (cartTrigger) cartTrigger.addEventListener('click', openDrawer);
  if (cartClose)   cartClose.addEventListener('click', closeDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // Lightbox : clic sur photos hero carrousel + photos des boîtes + galerie + sur mesure = ouverture en grand
  const clickableImages = document.querySelectorAll(
    '.hero-carousel-slide img, .custom-photo-main, .custom-photo-mini img, .box-img-wrap img, .box-gallery-item img'
  );
  clickableImages.forEach(img => {
    img.style.cursor = 'pointer';
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      const lb = document.getElementById('lightbox');
      const lbImg = document.getElementById('lightbox-img');
      lbImg.src = img.src;
      lbImg.alt = img.alt;
      lb.classList.add('active');
    });
  });

})();
